import * as z from "zod";
const errorMapping = {
    password_not_have_uppercase: "forgot_password.password_not_have_uppercase",
    password_not_have_lowercase: "forgot_password.password_not_have_lowercase",
    password_not_have_number: "forgot_password.password_not_have_number",
    password_not_match: "forgot_password.password_not_match",
    password_min_character: "forgot_password.password_min_character",
    password_empty: "forgot_password.password_empty",
};

export const forgotPasswordValidatorSchema = z
    .object({
        password: z
            .string({
                required_error: errorMapping.password_empty,
            })
            .min(8, {
                message: errorMapping.password_min_character,
            })
            .max(20)
            .regex(/[A-Z]/, { message: errorMapping.password_not_have_uppercase })
            .regex(/[a-z]/, { message: errorMapping.password_not_have_lowercase })
            .regex(/[0-9]/, { message: errorMapping.password_not_have_number }),
        confirm_password: z
            .string({
                required_error: errorMapping.password_empty,
            })
            .max(20),
    })
    .refine((data) => data.password === data.confirm_password, {
        message: errorMapping.password_not_match,
        path: ["confirm_password"], // path of error
    });

export type ForgotPasswordValidatorSchema = z.infer<typeof forgotPasswordValidatorSchema>;
